import React from "react";

// The printable gift card the purchaser gives to their recipient.
// Deliberately shows no amount and nothing about the purchaser.
// The QR code (rendered by the backend) opens the redeem page with the code
// already filled in.
export default function GiftCard({ code, qrSvg, redeemUrl }) {
  return (
    <div className="gift-card gift-print-area">
      <p className="gift-card-eyebrow">VerySoul</p>
      <h2 className="gift-card-title">You've been given a VerySoul Experience</h2>
      <p className="gift-card-text">
        Someone who wishes to remain anonymous is paying for you to have a private session with a VerySoul Verified
        Professional Medium.
      </p>
      <p className="gift-card-text">
        There's nothing you need to do until you're ready. When you'd like to use your gift, scan the
        QR code or enter your Gift Code at VerySoul.com, explore the mediums available to you, and choose
        the person and time that feel right for you.
      </p>
      <p className="gift-card-text">
        VerySoul is a community of fully vetted, compassionate evidential mediums from around the world.  You can learn more about what to expect by watching this video.
      </p>

      <div className="gift-card-code-row">
        {qrSvg && <img className="gift-card-qr" src={qrSvg} alt="QR code to redeem this gift" />}
        <div>
          <p className="gift-card-code-label">Your Gift Code</p>
          <p className="gift-card-code">{code}</p>
          {redeemUrl && <p className="gift-card-url">{redeemUrl.split("?")[0]}</p>}
        </div>
      </div>
    </div>
  );
}
